interface IDocumentViewProps {
  id: string;
  url: string;
}

export const DocumentView = ({ id, url }: IDocumentViewProps): JSX.Element => {
  return <iframe className="w-full h-full" key={id} src={url || "#"} />;
};
